module.exports = __webpack_public_path__ + "img/document.4fb065fd.svg";